import {Measure, volume, VolumeSystems, VolumeUnits} from "convert-units";

type newVolumeUnits = VolumeUnits | 'dm3' | 'dam3' | 'hm3' | 'dal' | 'hl';

const newVolume: Measure<VolumeSystems, newVolumeUnits> = {
  systems: {
    metric: {
      ...volume.systems.metric,
      dm3: {
        name: {
          singular: 'Cubic decimeter',
          plural: 'Cubic decimeters',
        },
        to_anchor: 1,
      },
      dam3: {
        name: {
          singular: 'Cubic decameter',
          plural: 'Cubic decameters',
        },
        to_anchor: 1000000,
      },
      hm3: {
        name: {
          singular: 'Cubic hectometer',
          plural: 'Cubic hectometers',
        },
        to_anchor: 1000000000,
      },
      dal: {
        name: {
          singular: 'Decalitre',
          plural: 'Decalitres',
        },
        to_anchor: 10,
      },
      hl: {
        name: {
          singular: 'Hectolitre',
          plural: 'Hectolitres',
        },
        to_anchor: 100,
      },
    },
  },
};

export default newVolume;
